(function () {
  'use strict';
  if (window.holyScrollSystem) return;
  window.holyScrollSystem = true;
  const mounted = new Map();
  function styleThemeArrows() {
    const selector = '.swiper-button-prev,.swiper-button-next,.slick-prev,.slick-next,.slider-button--prev,.slider-button--next,.hs-scroll-arrow,.hs-review-arrows button,.hs-comparison-prev,.hs-comparison-next,[data-hc-direction],.hs-recommendation-nav button,.hs-nutrition-modal button[aria-label="Tabela anterior"],.hs-nutrition-modal button[aria-label="Próxima tabela"],.cbb-also-bought-prev,.cbb-also-bought-next';
    document.querySelectorAll(selector).forEach(button => {
      if (button.classList.contains('hs-theme-arrow')) return;
      const label = button.getAttribute('aria-label') || '';
      const previous = button.matches('.swiper-button-prev,.slick-prev,.slider-button--prev,.hs-comparison-prev,.cbb-also-bought-prev,[data-hc-direction="-1"]') || /anterior/i.test(label) || button.matches('.hs-review-arrows button:first-child,.hs-recommendation-nav button:first-child') || button.textContent.trim() === '‹';
      if (!label) button.setAttribute('aria-label', previous ? 'Anterior' : 'Próximo');
      if (getComputedStyle(button).position === 'static') button.classList.add('hs-theme-arrow-static');
      button.classList.add('hs-theme-arrow');
      button.classList.toggle('hs-theme-arrow-prev', previous);
    });
  }
  const arrowTracks = new Map();
  function setArrowState(button, disabled) {
    if (!button) return;
    button.classList.add('hs-boundary-arrow');
    button.classList.toggle('hs-arrow-disabled', disabled);
    button.setAttribute('aria-disabled', String(disabled));
    if ('disabled' in button) button.disabled = disabled;
  }
  document.addEventListener('click', event => {
    if (event.target.closest('.hs-boundary-arrow[aria-disabled="true"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      return;
    }
    // Resolve the current instance at click time, before Swiper's own click guard.
    const button = event.target.closest('.hs-scroll-arrow,.hs-review-arrows button');
    const slider = button?.closest('.swiper,.swiper-container');
    const swiper = slider?.swiper;
    if (!button || !swiper || swiper.destroyed) return;
    event.preventDefault(); event.stopImmediatePropagation();
    /anterior/i.test(button.getAttribute('aria-label') || '') ? swiper.slidePrev() : swiper.slideNext();
  }, true);
  function bindArrows(el, swiper, getButtons) {
    if (arrowTracks.has(el)) return;
    const update = () => {
      if (swiper?.destroyed) return;
      const [previous, next] = getButtons();
      const noRoom = swiper ? swiper.isLocked || Math.abs(swiper.maxTranslate() - swiper.minTranslate()) <= 2 : el.scrollWidth - el.clientWidth <= 2;
      const bounds = el.getBoundingClientRect();
      const style = getComputedStyle(el);
      const slides = swiper ? Array.from(swiper.slides) : [];
      const first = slides[0]?.getBoundingClientRect();
      const last = slides[slides.length - 1]?.getBoundingClientRect();
      const start = swiper ? !swiper.params.loop && (swiper.isBeginning || first && first.left >= bounds.left + parseFloat(style.paddingLeft || 0) - 2) : el.scrollLeft <= 2;
      const end = swiper ? !swiper.params.loop && (swiper.isEnd || last && last.right <= bounds.right - parseFloat(style.paddingRight || 0) + 2) : el.scrollLeft >= el.scrollWidth - el.clientWidth - 2;
      previous.forEach(button => setArrowState(button, noRoom || start));
      next.forEach(button => setArrowState(button, noRoom || end));
    };
    const events = 'progress slideChange transitionEnd resize breakpoint update lock unlock reachBeginning reachEnd fromEdge';
    if (swiper) swiper.on(events, update);
    else el.addEventListener('scroll', update, { passive:true });
    const resize = new ResizeObserver(update);
    resize.observe(el);
    arrowTracks.set(el, {swiper, update, cleanup() { resize.disconnect(); if (swiper && !swiper.destroyed) swiper.off(events, update); else el.removeEventListener('scroll', update); }});
    update();
  }
  function scanArrows() {
    arrowTracks.forEach((entry, el) => { if (!el.isConnected || el.swiper?.destroyed || entry.swiper && entry.swiper !== el.swiper) { entry.cleanup(); arrowTracks.delete(el); } else entry.update(); });
    const elements = value => !value ? [] : value instanceof Element ? [value] : typeof value === 'string' ? [] : Array.from(value);
    document.querySelectorAll('.swiper,.swiper-container,.swiper-initialized').forEach(el => {
      const swiper = el.swiper;
      if (!swiper || swiper.destroyed) return;
      bindArrows(el, swiper, () => [
        [...elements(swiper.navigation?.prevEl), ...el.querySelectorAll('.hs-review-arrows button:first-child,.hs-scroll-arrow:first-child')],
        [...elements(swiper.navigation?.nextEl), ...el.querySelectorAll('.hs-review-arrows button:last-child,.hs-scroll-arrow:last-child')]
      ]);
    });
    document.querySelectorAll('.hs-nutrition-modal .carousel-modal-container').forEach(el => bindArrows(el, null, () => {
      const modal = el.closest('.hs-nutrition-modal');
      return [[...modal.querySelectorAll('[aria-label="Tabela anterior"]')][0], [...modal.querySelectorAll('[aria-label="Próxima tabela"]')][0]].map(button => button ? [button] : []);
    }));
    document.querySelectorAll('.hs-comparison-track').forEach(el => bindArrows(el, null, () => {
      const section = el.closest('.hs-comparison');
      return [[...section.querySelectorAll('.hs-comparison-prev')], [...section.querySelectorAll('.hs-comparison-next')]];
    }));
  }
  const nativeSelector = '.hs-comparison-track,.hc-track,.hc-banner-track,.cbb-also-bought-slider';
  const visible = el => !!el && el.getClientRects().length > 0 && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden';
  function shouldMount(el) {
    if (!document.body.matches('.template-index,.template-product') && !el.matches('.slider-blog-hs')) return false;
    if (el.matches('.hc-track,.hc-banner-track')) return false;
    if (el.matches('.slide-home')) return true;
    // Kits keep their directional arrows and the standard pagination below the cards.
    if (document.body.matches('.template-index') && el.matches('.product-carousel')) return true;
    const region = el.closest('.shopify-section,.hs-comparison') || el.parentElement;
    return !Array.from(region.querySelectorAll('.swiper-button-next,.swiper-button-prev,.hs-comparison-next,.cbb-also-bought-next,.cbb-also-bought-prev')).some(visible);
  }
  let serial = 0, pending;
  const clamp = n => Math.max(0, Math.min(1, Number(n) || 0));
  const duration = () => 180;
  function mount(el, swiper) {
    if (mounted.has(el)) return;
    const bar = document.createElement('div');
    bar.className = 'hs-scroll-control';
    const input = document.createElement('input');
    input.type = 'range'; input.min = '0'; input.max = '1000'; input.step = '1'; input.value = '0';
    if (!el.id) el.id = 'hs-scroll-track-' + (++serial);
    const region = el.closest('section,.shopify-section,.hc-shelf,.hc-campaign');
    const heading = region && (region.querySelector('h1') || region.querySelector('h2,h3'));
    input.setAttribute('aria-label', 'Arrastar para navegar' + (heading ? ': ' + heading.textContent.trim() : ' pelo carrossel'));
    input.setAttribute('aria-controls', el.id);
    const indicator = document.createElement('div'); indicator.className = 'hs-scroll-dots'; indicator.setAttribute('aria-hidden','true');
    const track = document.createElement('div'); track.className = 'hs-scroll-indicator';
    track.append(indicator,input); bar.append(track);
    // Keep Swiper controls in their own visual block, at the original pagination slot.
    // Native scrolling tracks need a sibling so the control itself does not scroll.
    if (swiper) {
      const slot = el.querySelector(':scope > .swiper-pagination');
      if (slot) slot.before(bar); else el.append(bar);
    } else el.after(bar);
    const banner = el.matches('.slide-home,.hc-banner-track');
    if (banner) bar.classList.add('hs-banner-navigation');
    if (banner) [-1,1].forEach(direction => {
      const arrow = document.createElement('button'); arrow.type='button'; arrow.className='hs-scroll-arrow';
      arrow.textContent=direction<0?'‹':'›'; arrow.setAttribute('aria-label',direction<0?'Banner anterior':'Próximo banner');
      arrow.addEventListener('click',()=>{if(swiper){direction<0?swiper.slidePrev():swiper.slideNext();}else el.scrollBy({left:direction*el.clientWidth,behavior:'smooth'});});
      if(direction<0)bar.prepend(arrow);else bar.append(arrow);
    });
    const old = [];
    if (swiper) {
      const pagination = swiper.pagination && swiper.pagination.el;
      if (pagination) old.push(...(pagination instanceof Element ? [pagination] : Array.from(pagination)));
      el.querySelectorAll(':scope > .swiper-pagination,:scope > .swiper-scrollbar').forEach(p => old.push(p));
    } else {
      el.classList.add('hs-scroll-native');
      const area = el.closest('.hs-comparison,.hc-campaign');
      if (area) area.querySelectorAll('.hs-comparison-dots,.hc-banner-dots,.hs-comparison-next').forEach(p => old.push(p));
    }
    old.forEach(p => p.classList.add('hs-scroll-old-pagination'));
    const abort = new AbortController(), signal = abort.signal;
    let dragging = false, resumeAutoplay = false, oldSnap = '', oldBehavior = '';
    const count = () => {
      const slides = Array.from(swiper.slides).filter(s => !s.classList.contains('swiper-slide-duplicate'));
      return Math.max(1, slides.length);
    };
    const update = () => {
      if (swiper && swiper.destroyed) return;
      const available = swiper ? !swiper.isLocked && count() > 1 && (swiper.params.loop || Math.abs(swiper.maxTranslate() - swiper.minTranslate()) > 1) : el.scrollWidth > el.clientWidth + 2;
      bar.hidden = !available;
      const progress = swiper ? (swiper.params.loop ? swiper.realIndex / Math.max(1, count() - 1) : swiper.progress) : el.scrollLeft / Math.max(1, el.scrollWidth - el.clientWidth);
      const steps = swiper ? (swiper.params.loop ? count() : swiper.snapGrid.length) : Math.max(2,Math.ceil(el.scrollWidth/el.clientWidth));
      if(indicator.children.length!==steps) indicator.replaceChildren(...Array.from({length:steps},()=>document.createElement('span')));
      const current=Math.round(clamp(progress)*(steps-1));
      Array.from(indicator.children).forEach((dot,i)=>dot.classList.toggle('is-active',i===current));
      if(!dragging) input.value = String(Math.round(clamp(progress) * 1000));
      input.setAttribute('aria-valuetext', Math.round(clamp(progress) * 100) + '% do carrossel');
    };
    const start = () => {
      if (dragging) return;
      dragging = true;
      if (swiper) { resumeAutoplay = !!swiper.autoplay?.running; if (resumeAutoplay) swiper.autoplay.stop(); }
      else { oldSnap = el.style.scrollSnapType; oldBehavior = el.style.scrollBehavior; el.style.scrollSnapType = 'none'; el.style.scrollBehavior = 'auto'; }
    };
    const move = () => {
      start();
      const progress = Number(input.value) / 1000;
      if (swiper) {
        if (swiper.params.loop) swiper.slideToLoop(Math.round(progress * (count() - 1)), 0);
        else swiper.setProgress(progress, 0);
      } else el.scrollLeft = progress * (el.scrollWidth - el.clientWidth);
      input.setAttribute('aria-valuetext', Math.round(progress * 100) + '% do carrossel');
    };
    const end = () => {
      if (!dragging) return;
      dragging = false;
      if (swiper && !swiper.destroyed) {
        if (!swiper.params.loop) swiper.slideToClosest(duration());
        if (resumeAutoplay) swiper.autoplay.start();
      } else { el.style.scrollSnapType = oldSnap; el.style.scrollBehavior = oldBehavior; }
      requestAnimationFrame(update);
    };
    input.addEventListener('pointerdown', start, {signal});
    input.addEventListener('input', move, {signal});
    input.addEventListener('change', end, {signal});
    input.addEventListener('blur', end, {signal});
    window.addEventListener('pointerup', end, {signal});
    window.addEventListener('pointercancel', end, {signal});
    const events = 'progress slideChange resize breakpoint update lock unlock';
    const onSwiperUpdate = () => requestAnimationFrame(update);
    if (swiper) swiper.on(events, onSwiperUpdate);
    else el.addEventListener('scroll', update, {passive:true,signal});
    const resize = new ResizeObserver(update); resize.observe(el);
    mounted.set(el, {swiper, update, cleanup() { abort.abort(); resize.disconnect(); if (swiper && !swiper.destroyed) swiper.off(events, onSwiperUpdate); bar.remove(); old.forEach(p => p.classList.remove('hs-scroll-old-pagination')); el.classList.remove('hs-scroll-native'); }});
    update();
  }
  function scan() {
    styleThemeArrows();
    scanArrows();
    mounted.forEach((entry, el) => {
      if (!el.isConnected || !shouldMount(el) || (entry.swiper && (entry.swiper.destroyed || el.swiper !== entry.swiper))) { entry.cleanup(); mounted.delete(el); }
      else entry.update();
    });
    // Only browsing shelves and campaign banners need this extra navigation.
    // Product galleries already have thumbnails; automatic claims need no control.
    document.querySelectorAll('.slide-home,.product-carousel,.product-carousel-v2,.slider-blog-hs,.slider-persona-hs').forEach(el => {
      const s = el.swiper;
      if (s && !s.destroyed && s.isHorizontal() && shouldMount(el)) mount(el, s);
    });
    document.querySelectorAll(nativeSelector).forEach(el => { if (!el.swiper && shouldMount(el)) mount(el, null); });
  }
  const schedule = () => { clearTimeout(pending); pending = setTimeout(scan, 120); };
  function init() {
    scan();
    new MutationObserver(records => {
      if (records.some(r => r.type === 'childList' ? [...r.addedNodes,...r.removedNodes].some(n => n.nodeType === 1 && !n.matches('.hs-scroll-control')) : r.target.matches('.swiper,.swiper-container,.swiper-initialized'))) schedule();
    }).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('hs:carousel-ready', schedule);
    window.addEventListener('load', schedule);
    setTimeout(scan, 800); setTimeout(scan, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
